import { createRouter } from '@tanstack/react-router';
import { payloadParseSearch, payloadStringifySearch } from '@payloadcms/tanstack-start/shared';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  return createRouter({
    routeTree,
    parseSearch: payloadParseSearch,
    stringifySearch: payloadStringifySearch,
    scrollRestoration: true,
    defaultPreload: 'intent',
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
